import React from "react";
import { Link } from "@skbkontur/react-ui";

import { CheckedReport } from "../../../../../Engine/Core/ErrorManager/Utils/Models";

import { CheckedReportWrapper } from "./InterdocumentCheckedReport.styles";

interface InterdocumentCheckedReportProps {
    report: CheckedReport;
}

export const InterdocumentCheckedReport = (props: InterdocumentCheckedReportProps) => (
    <CheckedReportWrapper>
        {props.report.url ? (
            <Link href={props.report.url} target="_blank" rel="noreferrer">
                {props.report.caption}
            </Link>
        ) : (
            <span>{props.report.caption}</span>
        )}
    </CheckedReportWrapper>
);
